/**
 * Resolves one service instance per Nuxt app: per-request on the server,
 * app-lifetime singleton on the client.
 *
 * Module-scoped singletons leak state across SSR requests because module scope
 * is process scope on the Nitro server. Caching on the Nuxt app instance keeps a
 * fresh instance per request on the server while staying a singleton on the client.
 *
 * @param {string} name Unique service slug used as the cache key.
 * @param {(nuxtApp: object) => object} factory Builds the service instance.
 */
export function defineServiceComposable(name, factory) {
  return function useServiceInstance() {
    const nuxtApp = useNuxtApp()
    const container = (nuxtApp._services ??= new Map())

    if (!container.has(name)) {
      container.set(name, factory(nuxtApp))
    }

    return container.get(name)
  }
}
